import _taggedTemplateLiteralLoose from 'babel-runtime/helpers/taggedTemplateLiteralLoose';

var _templateObject = _taggedTemplateLiteralLoose(['\n  query getUnifiedTutoringSchedulerLaunchInfo {\n    unifiedTutoringSchedule {\n      url\n      token\n    }\n  }\n'], ['\n  query getUnifiedTutoringSchedulerLaunchInfo {\n    unifiedTutoringSchedule {\n      url\n      token\n    }\n  }\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  query getUnifiedTutoringNextSessionStartTime {\n    unifiedTutoringNextSessionForStudent {\n      startTime\n    }\n  }\n'], ['\n  query getUnifiedTutoringNextSessionStartTime {\n    unifiedTutoringNextSessionForStudent {\n      startTime\n    }\n  }\n']);

import gql from 'graphql-tag';

export var TutoringSchedulerLaunchInfoQuery = gql(_templateObject);

export var TutoringNextSessionStartTimeQuery = gql(_templateObject2);